import React from "react";
import "./style.css";

export const Instructions = () => (
    <div className="Instructions">
        <span>Share your photo on social media, or download to your device</span>
    </div>
);
